module.exports = __webpack_public_path__ + "static/media/medefy-logo.0100d17b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/medefy-logo.png
// module id = 751
// module chunks = 0